import { Component, OnInit } from '@angular/core';
import { AccountService } from 'src/app/services/account.service';
import { environment } from 'src/environments/environment';
import { Subscription } from "rxjs";
import { UtilsService } from 'src/app/services/utils.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  adminAppUrl: string = environment.adminAppUrl;
  sectionShown="accueil";
  safariClass="";
  utilisateur: any;
  subscription: Subscription;
  constructor(private accountService:AccountService,private utilsService: UtilsService,public router: Router) {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') != -1) {
      if (ua.indexOf('chrome') > -1) {
        this.safariClass="";
      } else {
        this.safariClass="isSafari";
      }
    }
    this.subscription=this.accountService.getAccount().subscribe(account=>{
      if(account){
        this.utilisateur = JSON.parse(localStorage.getItem('microFinance'));
      }
    });
  }

  ngOnInit(): void {
    let section = localStorage.getItem('sectionShown');
    if(section!=undefined && section && section!=''){
      this.sectionShown=section;
    }
    else { this.sectionShown="accueil";
    }
    if(localStorage.getItem('microFinance')){
      this.utilisateur = JSON.parse(localStorage.getItem('microFinance'));
    }
  }
  getRoute(route,type){
    localStorage.setItem('route',route);
    this.sectionShown=type;
    localStorage.setItem('sectionShown',type);
  }


  deconnexion(){
    localStorage.removeItem('microFinance');
    this.router.navigate(['/']);
    this.accountService.sendAccount('');
    this.utilsService.showToastSuccess("Effectué avec succès", "Déconnexion");
   }

}
